module.exports = __webpack_public_path__ + "static/Logo-91f11cd8bc6907cc1230c280428b52f7.png";